import React from "react";
import correctCircleFill from "../../assets/images/correctCircleFill.png";
import closeSmallLine from "../../assets/images/closeSmallLine.png";
import "./index.less";
var RateSuccess = function RateSuccess(_ref) {
  var visible = _ref.visible,
    handleClose = _ref.handleClose;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "rate-success ".concat(visible ? "open" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: 'rate-success-header'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'rate-success-header-title'
  }, /*#__PURE__*/React.createElement("img", {
    src: correctCircleFill,
    alt: "",
    style: {
      width: '20px',
      marginRight: '10px'
    }
  }), "\u60A8\u7684\u8BC4\u4EF7\u5DF2\u6536\u5230"), /*#__PURE__*/React.createElement("div", {
    className: 'rate-success-header-close',
    onClick: function onClick() {
      handleClose === null || handleClose === void 0 ? void 0 : handleClose();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: closeSmallLine,
    alt: "",
    style: {
      width: '24px',
      verticalAlign: 'middle'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'rate-success-content'
  }, "\u611F\u8C22\u4F60\u7684\u8BC4\u4EF7\u53CA\u5EFA\u8BAE\uFF0C\u6211\u4EEC\u5C06\u6301\u7EED\u52AA\u529B\u4E3A\u4F60\u5E26\u6765\u826F\u597D\u7684\u7ECF\u8425\u4F53\u9A8C\u3002")));
};
export default RateSuccess;